import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Stack, Tab, Tabs, Typography, tabsClasses } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import Label from "../../../components/Common/Label";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import Helpers from "../../../helpers/helpers";
import { getConfigurationDetails, getConfigurationListing } from "../../../store/actions";
import "../../Orders/order.css";
import ConfigProductSpecFiled from "./ConfigProductSpecFiled";

const ConfigProductSpec = ({ setFormValues, values, error, configurationListing, setNotification, categoryForTab, setConfigurationItemId, productListing, width, configurationDetails, setAllowMultipleSelect, allowMultipleSelect }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    setTabsData(configurationListing)
  }, [configurationListing]);

  const [openServicesField, setOpenServicesField] = useState(false)
  const [TabsData, setTabsData] = useState(configurationListing)
  const [editId, setEditId] = useState("")
  const [edit, setEdit] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [tabsDataArry, setTabDataArry] = useState({})
  const [errorEmpty, setError] = useState(false)
  const [tempServices, setTempServices] = useState({
    configuration_id: "",
    configuration_item_id: "",
    display_name: "",
    additional_info: "",
    sku: "",
    quantity: "",
    is_default: 0,
    add_price: ""
  })

  useEffect(() => {
    if (tabsDataArry?.id) {

      dispatch(getConfigurationDetails({ id: tabsDataArry?.id }))
    }
  }, [tabsDataArry?.id]);

  useEffect(() => {
    if (tabValue !== null && tabValue !== undefined && tabValue !== "") {
      Helpers.getValueFromDataForProductSpecTab(configurationListing, tabValue, setTabDataArry, setAllowMultipleSelect,)
    } else {
      Helpers.getValueFromDataForProductSpecTab(configurationListing, 0, setTabDataArry, setAllowMultipleSelect)
    }
  }, [configurationListing, tabValue, tabsDataArry?.id, values?.product_categories]);

  useEffect(() => {
    let payload = {
      paginate: 0,
      sort_order: "asc",
      size: "",
      search: "",
      sort: "",
      allow_multiple_select: "",
      allow_quantity_selection: "",
      category_name: categoryForTab || -1,
    }
    if (categoryForTab?.length > 0)
      dispatch(getConfigurationListing(payload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryForTab]);

  const [tempServicesEmpty, setTempServicesEmpty] = useState({
    configuration_id: "",
    configuration_item_id: "",
    display_name: "",
    additional_info: "",
    sku: "",
    quantity: "",
    is_default: 0,
    add_price: "",
    deduct_quantity: 0,
    product_id: "",
    purchase_limit: null,
  },)

  const handleDeleteFiles = (id) => {
    const tempFile = values?.variants;

    if (!tempFile || tempFile?.length === 0) {
      return; // Safeguard for empty or undefined `variants`
    }
    // Filter the variants array by tabsDataArry?.id (or other identifier)
    const filteredFile = tempFile?.length > 0 && tempFile?.filter((item) => item.configuration_id === tabsDataArry?.id);
    // Get the item to delete using the given index in the filtered array
    const itemToDelete = filteredFile[id];
    if (!itemToDelete) {
      return; // Safeguard for invalid id
    }
    // Find the real index of the item in the original array based on matching the object
    const realIndex = tempFile?.length > 0 && tempFile.findIndex((item) => item === itemToDelete);
    if (realIndex === -1) {
      return; // Safeguard for unexpected issues
    }
    // Create a new array without the item at the real index
    const updatedFile = tempFile?.length > 0 && tempFile.filter((_, idx) => idx !== realIndex);
    // Update the form values with the filtered array
    setFormValues((prevValues) => ({
      ...prevValues,
      variants: updatedFile,
    }));
  };

  const handleEditFiles = (id) => {
    const tempFile = values?.variants;
    if (!tempFile || tempFile.length === 0) {
      return; // Safeguard for empty or undefined `product_services`
    }
    // Filter the array by the relevant criteria (e.g., tabsDataArry?.id or any other condition)
    const filteredFiles = tempFile && tempFile?.length > 0 && tempFile.filter((x) => x.configuration_id === tabsDataArry?.id);
    if (id < 0 || id >= filteredFiles.length) {
      return;
    }
    // Find the original item in `tempFile` based on the filtered array's item
    const originalItemIndex = tempFile && tempFile?.length > 0 && tempFile.findIndex((x) => x === filteredFiles[id]);
    const originalItem = tempFile[originalItemIndex];
    if (originalItem) {
      setEdit(true);
      setEditId(id); // Use the index in the original array
      setTempServices(originalItem);
      setOpenServicesField(false)
    }
  };

  const handleSaveEdit = (id) => {
    let validate = check(tempServices)
    console.log("validate", tempServices)
    if (validate) {
      setEditId(id);
      setEdit(false);
      const tempFile = values?.variants;
      // Filter the variants by tabsDataArry?.id
      const filteredServices = tempFile && tempFile?.length > 0 && tempFile?.filter(
        (service) => service?.configuration_id === tabsDataArry?.id
      );
      // Get the item from the filtered array
      const filteredItem = filteredServices?.[id];
      // Find the real index in the original array of variants
      const realConfigIndex = tempFile && tempFile?.length > 0 && tempFile?.findIndex((service) => service === filteredItem);
console.log("dfsfd", filteredItem, )
      if (realConfigIndex !== -1) {
        addPorperties(realConfigIndex)
      }
    }

  };

  const addPorperties = (realPropertiesIndex) => {
    if (realPropertiesIndex !== -1) {
      // Update the variants array
      setFormValues((prevValues) => {
        const updatedProperties = [...(prevValues?.variants ?? [])]; // Ensure it's an array
        updatedProperties[realPropertiesIndex] = {
          ...updatedProperties[realPropertiesIndex],
          id: tempServices?.id,
          configuration_id: tabsDataArry?.id,
          configuration_item_id: tempServices?.configuration_item_id,
          display_name: tempServices?.display_name,
          additional_info: tempServices?.additional_info,
          sku: tempServices?.sku,
          quantity: tempServices?.quantity,
          is_default: tempServices?.is_default,
          deduct_quantity: tempServices?.deduct_quantity,
          product_id: tempServices?.product_id,
          add_price: tempServices?.add_price,
          purchase_limit: tempServices?.purchase_limit,
          sort_order: tempServices?.sort_order,
          group_name: tempServices?.group_name,
        };
        return {
          ...prevValues,
          variants: updatedProperties,
        };
      });
    }

    setTempServices({
      configuration_id: "",
      configuration_item_id: "",
      display_name: "",
      additional_info: "",
      sku: "",
      quantity: "",
      is_default: 0,
      add_price: "",
      purchase_limit: "",
      sort_order: "",
      group_name: "",
    });
  }

  const check = (data) => {
    if (!data?.display_name || !data?.configuration_item_id
      // || (allowMultipleSelect ? !data?.purchase_limit : data?.purchase_limit)
    ) {
      setError(true)
      setNotification({
        open: true,
        msg: "Please complete product sepcification section!",
        type: "warning"
      })
      return false
    } else {

      return true


    }
  }

  const handleAddServices = () => {
    // let validate = tempServicesEmpty
    let validate = check(tempServicesEmpty)
    if (validate) {
      let temp = values?.variants || []
      let data = {
        configuration_id: tabsDataArry?.id,
        configuration_item_id: tempServicesEmpty?.configuration_item_id,
        display_name: tempServicesEmpty?.display_name,
        additional_info: tempServicesEmpty?.additional_info,
        sku: tempServicesEmpty?.sku,
        quantity: tempServicesEmpty?.quantity,
        is_default: tempServicesEmpty?.is_default,
        add_price: tempServicesEmpty?.add_price,
        deduct_quantity: tempServicesEmpty?.deduct_quantity,
        product_id: tempServicesEmpty?.product_id,
        purchase_limit: tempServicesEmpty?.purchase_limit,
        sort_order: tempServicesEmpty?.sort_order || 0,
        group_name: tempServicesEmpty?.group_name,
      }
      temp?.push(data)
      setFormValues((prevValues) => ({
        ...prevValues,
        variants: temp
      }))

      setTempServicesEmpty({
        configuration_id: "",
        configuration_item_id: "",
        display_name: "",
        additional_info: "",
        sku: "",
        quantity: "",
        is_default: 0,
        add_price: ""
      })

      setOpenServicesField(false)
    }
  }

  return (
    <React.Fragment>

      <Card className="p-3" style={{ minHeight: "40vh" }}>
        <CardBody>
          <div className="setting-header">PRODUCT SPECS</div>
          {error && <FormHelperText sx={{ color: "red" }}>{error?.product_services}</FormHelperText>}
          {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "variants.")}</FormHelperText>}
          <Divider className="my-2 mb-4" />
          {values?.product_categories?.length > 0 && categoryForTab?.length > 0 && configurationListing?.length > 0 ?
            <Grid container sx={{ border: { sm: '1px solid #D0D0D0', xs: "1px solid #D0D0D0" }, borderRadius: "5px" }} padding={{ sm: 2, xs: 2 }}>
              <Grid item xs={12} style={{ width: width > 568 ? "auto" : "50vw" }} >
                <Tabs value={tabValue} scrollButtons={true} onChange={(e, val) => (setTabValue(val), setEditId(""), setOpenServicesField(false))} aria-label="basic tabs example" variant="scrollable" TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }}
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      '&.Mui-disabled': { opacity: 0.3 },
                    },
                  }}
                >
                  {
                    TabsData && TabsData?.length > 0 && TabsData.map((x, idx) =>
                      <Tab key={idx} label={<div className="d-flex" style={{ color: parseInt(tabValue) === idx ? '#282828' : '#A0A0A0' }}>{x?.descriptions?.[0]?.name}</div>} />
                    )
                  }
                </Tabs>
              </Grid>
              <Grid item xs={12} pt={2}>
                <Stack direction={{ xs: "column", sm: "row" }} style={{ flex: 1, }} pt={2} gap={1} justifyContent={"space-between"}>
                  <Stack direction={"row"} gap={1}>
                    <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <i className={tabsDataArry?.icon || ""} style={{ fontSize: "24px" }}></i>
                    </div>
                    <div>
                      <span className="setting-form-section-header" >{tabsDataArry?.name}</span>
                      <Typography><span className="setting-form-subtitle">{values?.variants?.filter((x, id) => x.configuration_id === tabsDataArry?.id)?.length} options</span></Typography>
                    </div>
                  </Stack>
                  <Stack display={"contents"} justifyContent={{ xs: "flex-start", sm: "flex-end" }}>
                    <CustomButton
                      borderStyle={"1px solid #282828"}
                      title={"Add option"}
                      press={() => (setOpenServicesField(true), setEditId(""))}
                      height={40}
                      backgroundColor={'white'}
                      textColor={'#282828'}
                    />
                  </Stack>
                </Stack>
              </Grid>
              {/* render card  */}
              <Grid container spacing={1} mt={{ sm: 3, xs: 1 }} style={{ minHeight: "30vh" }}>
                {values?.variants && values?.variants.length > 0 ?
                  values?.variants?.filter((x, id) => x.configuration_id === tabsDataArry?.id).length > 0 ?
                    values?.variants?.filter((x, id) => x.configuration_id === tabsDataArry?.id).map((x, i) => {
                      return (
                        <React.Fragment key={i}>
                          {
                            <Grid item xs={12} sm={6}>
                              <div
                                className="mt-1 mb-0"
                                style={{ border: "1px solid #d0d0d0", borderRadius: "8px", padding: "10px", paddingTop: "15px", paddingBottom: "15px" }}
                              >
                                <Stack flexDirection={{ xs: "column", sm: "row" }} justifyContent={"space-between"}>
                                  <div className="p-2">
                                    <Stack direction={"column"} gap={1}>
                                      <span className="" style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828", paddingBottom: "5px" }}>
                                        {x?.display_name}
                                      </span>
                                    </Stack>
                                    <Typography><span className="setting-form-subtitle">{x?.additional_info}</span></Typography>
                                    {
                                      x?.is_default === 1 && <Label.CustomLabel label={'Default Selected'} backgroundColor={"#F1F1F1"} />
                                    }
                                  </div>
                                  <div className="d-flex justify-content-end">
                                    {x.default &&
                                      <div><CustomIconButton
                                        iconName={'ri-eye-line'}
                                        onClick={(e) => ""} /></div>
                                    }
                                    <div><CustomIconButton
                                      iconName={'ri-pencil-line'}
                                      onClick={(e) => handleEditFiles(i)}
                                    /></div>
                                    {
                                      !x.default &&
                                      <div><CustomIconButton
                                        iconName={'ri-delete-bin-line'}
                                        onClick={(e) => handleDeleteFiles(i)}
                                        backgroundColor={'#44d62c'}
                                        color={'white'}
                                        borderStyle={"1px solid #44d62c"}
                                      /></div>}
                                  </div>

                                </Stack>
                                {/* {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "variants.")}</FormHelperText>} */}

                              </div>

                            </Grid>
                          }
                          {
                            edit && editId === i &&
                            <Grid item xs={12}>
                              <ConfigProductSpecFiled setNotification={setNotification} setOpenServicesField={setOpenServicesField} tempServices={tempServices} setTempServices={setTempServices} handleAddServices={handleAddServices}
                                edit={edit} setEditId={setEditId} handleSaveEdit={handleSaveEdit} id={i} setEdit={setEdit} tabValue={tabValue} TabsData={TabsData} tabsDataArry={tabsDataArry}
                                setConfigurationItemId={setConfigurationItemId} productListing={productListing} configurationDetails={configurationDetails}
                                error={errorEmpty} setError={setError} allowMultipleSelect={allowMultipleSelect} />
                            </Grid>}

                        </React.Fragment>
                      );
                    })

                    :
                    !openServicesField && <span className="text-muted" style={{ width: "100%", textAlign: "center", alignSelf: "anchor-center" }}>No option added</span>
                  :
                  !openServicesField && <span className="text-muted" style={{ width: "100%", textAlign: "center", alignSelf: "anchor-center" }}>No option added</span>

                }

                {
                  openServicesField &&
                  <ConfigProductSpecFiled setNotification={setNotification} setOpenServicesField={setOpenServicesField} tempServices={tempServicesEmpty} setTempServices={setTempServicesEmpty}
                    handleAddServices={handleAddServices} edit={false} setEditId={setEditId} tabValue={tabValue} TabsData={TabsData} tabsDataArry={tabsDataArry}
                    setConfigurationItemId={setConfigurationItemId} productListing={productListing} configurationDetails={configurationDetails}
                    error={errorEmpty} setError={setError} allowMultipleSelect={allowMultipleSelect} />
                }
              </Grid>
            </Grid>
            :
            <span className="text-muted">No configurations found for this product's category.</span>
          }
        </CardBody>
      </Card>

    </React.Fragment >
  );
};

function mapStateToProps({ Configuration, General }) {
  return {
    configurationListing: Configuration.configurationListing?.data,
    specTab: General.configurations,
    configurationDetails: Configuration.configurationDetails,

  };
}



export default connect(mapStateToProps)(ConfigProductSpec);
